export const StoryVariables = {
    MAX_PLAYER_TURNS: "maxPlayerTurns",
    OUTCOME_PREFIX: "outcome_",
};